module.exports = ".role{\r\n    font-style: italic;\r\n}\r\n.name{\r\n    font-weight: 400 ;\r\n    font-size: 14px;\r\n    text-align: center;\r\n}\r\n.header {\r\n  color: black;\r\n  padding: 40px 0 20px;\r\n  text-align: center;\r\n}\r\n.header h1 {\r\n  font-size: 40px;\r\n  font-weight: bold;\r\n}\r\n.header h2 a {\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\r\n  color: black;\r\n  font-size: 20px;\r\n  opacity: 0.5;\r\n}\r\n.header h2 a:hover {\r\n  border-bottom-color: white;\r\n  opacity: 1;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/public/contacts/contacts.component.css
// module id = ./src/app/public/contacts/contacts.component.css
// module chunks = main